/** @jsxImportSource @emotion/react */
import { CircularProgress, CircularProgressProps } from '@mui/material';
import React from 'react';

export const LoadingSpinner = ({
  className,
  color,
  size,
}: { className?: string } & Pick<CircularProgressProps, 'color' | 'size'>) => (
  <CircularProgress className={className} color={color} size={size} />
);
